<template lang="html">
  	<entity-page id="page__stock" v-bind:loading="progress">
	  	<template slot="header-left">
			<span v-if="stock.name"> {{'Склад ' + stock.name}} </span>
			<span v-else> Новый склад </span>
        </template>
  		<template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded @click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded @click="save"></z-icon-button>
        </template>

		<FlexTabs v-if="stock.id && stock.id != 'new'" v-bind:tabs="tabs" v-model="activeTab" min />

		<div v-if="activeTab === 'tab-stock'">
			<z-input
				v-model="stock.name" v-bind:required="true"
				name="name" id="name" label="Название"  placeholder="Введите название склада"
				v-validate="'required|min:2'" data-vv-name="name" v-bind:data-vv-as="' '" v-bind:error="errors.first('name')"
			></z-input>
			<z-input-autocomplete
				v-bind:callback="getCities" v-model="stock.city_id"
				v-bind:length-on-search="3" v-bind:update-on-input="true"
				v-bind:default="(stock.city && stock.city.name ? stock.city.name : '')"
				label="Город" display-property="label" property="id" name="city_id" id="city_id" data-vv-name="city_id" required
				v-validate="'required'" v-bind:data-vv-as="' '" v-bind:error="errors.first('city_id')" placeholder="Введите наименование города/населенного пункта"
			></z-input-autocomplete>
			<z-input
				v-model="stock.description"
				name="description" id="description" label="Описание" 
				v-validate="'min:2|max:255'" data-vv-name="description" v-bind:data-vv-as="' '" v-bind:error="errors.first('description')"
			></z-input>
		</div>

		<stock-printers
			v-if="stock.printers && stock.printers.length && activeTab === 'tab-printers'"
			v-bind:value="stock.printers"
		></stock-printers>

		<z-input-stock-zones
			v-if="stock.id && stock.id != 'new' && activeTab === 'tab-zones'"
			v-bind:stock="stock" ref="zones"
		></z-input-stock-zones>

		<comments-and-logs
			v-if="stock.id && stock.id != 'new' && activeTab === 'tab-history'"
			v-bind:entity_id="parseInt(stock.id)"
			entity="stoсks"
			ref="history" module="stoсks"
		></comments-and-logs>

  	</entity-page>
</template>
<script>
	import ZInputAutocomplete from '@/components/ZInputAutocomplete';
	import ZInput from '@/components/ZInput';
	import ZIconButton from '@/components/ZIconButton';
    import ZInputStockZones   from '@/components/ZInputStockZones';
	import FlexTabs from '@/components/FlexTabs';
	import EntityPage   from '@/components/EntityPage.vue';
	import ToggleCard   from '@/components/ToggleCard';
	import StockPrinters from '../components/StockPrinters.vue'
	import commentsAndLogs  from '@/components/CommentsAndLogs'
	export default {
		components: {
			ZInputAutocomplete, ZInput, ZIconButton, ZInputStockZones,
			EntityPage, ToggleCard, StockPrinters, FlexTabs, commentsAndLogs
		},
		data() {
			return {
				stock: {},
				stockDefault: {
					name: null,
					city_id: null,
					description: null,
					freight_count: null,
					id: null,	
				},
				cities: [],
				activeTab: 'tab-stock',
                tabs: [
                    {name: "tab-stock",    label: "Параметры"},
                    {name: "tab-printers", label: "Принтеры"},
					{name: "tab-zones",    label: "Направления"},
					{name: "tab-history",  label: "История"},
                ],				
			}
		},
		computed: {
			/**
			 * Флаг загрузки текущего компонента
			 */
			progress() {
				return this.progressObj['load-stock-card'];
			},
			/**
			 * Объект с флагами загрузки
			 */
			progressObj() {
				return this.$store.state.progressObj;
			}
		},
		watch: {
			'$route.params.stock_id'() {
				this.getStock();
				this.$store.commit('openRightPanel');
			},
		},
		created() {
			this.init();
		},
		methods: {
			/**
			 * Инициализация компонента
			 */
			init() {
				this.$nextTick(() => {
                    this.stock = Object.assign({}, this.stockDefault); 
					if (this.$route.params.stock_id != 'new') this.getStock();
                });
				this.$store.commit('openRightPanel');
				if (this.stock && this.stock.name) this.$store.commit('setTitle', ('Склады | ' + this.stock.name));
			},
			/**
			 * Получение склада
			 */
			getStock() {
				this.$store.commit('showProgressBar', 'load-stock-card');
				this.$store.dispatch('stock/getStock', {id: this.$route.params.stock_id}).then(r => {
					if (!r) return;
					this.stock = Object.assign({}, r);
					return this.stock;
				}).finally(() => this.$store.commit('hideProgressBar', 'load-stock-card'));
			},
			/**
			 * Шаг назад
			 */
			back() {
				this.$router.push({name: 'Stocks', query: this.$route.query});
			},
			/**
			 * Сохранение
			 */
			save() {
				this.$validator.validateAll().then(valid => {
                    if (!valid) return;
					if (this.$route.params.stock_id != 'new') this.putStock();
					else this.postStock();
				})
			},
			/**
			 * Добавление склада
			 */
			postStock() {
				this.$store.commit('showProgressBar', 'load-stock-card');
				this.$store.dispatch('stock/postStock', this.stock).then(r => {
					if (!r) return;
					this.$root.$emit('reload-table', 'stocks');
					this.$router.replace({name: 'Stocks', params: {stock_id: r.id}});
				}).finally(() => this.$store.commit('hideProgressBar', 'load-stock-card'));
			},
			/**
			 * Изменение склада
			 */
			putStock() {
				this.$store.commit('showProgressBar', 'load-stock-card');
				this.$store.dispatch('stock/putStock', this.stock).then(r => {
					if (!r) return;
					this.$root.$emit('reload-table', 'stocks');
					this.getStock();
				}).finally(() => this.$store.commit('hideProgressBar', 'load-stock-card'));
			},
			/**
			 * Получение городов
			 */
			getCities(searchString) {
				if (searchString.length >= 3) 
					return this.$store.dispatch('stock/getCities', { name: searchString }).then(r => {
						return r.map(item => {
							item.label = (item.value) ? item.value : item.name; 
							return item;
						});
					});
			}
		}
	}
</script>


// WEBPACK FOOTER //
// Stock.vue?19b23dda